// extracted by mini-css-extract-plugin
module.exports = {"container":"ySL9GeSenKG2L2wpOl8j1","groupsList":"_395JMkI_EaBK9gSqlZOT8n"};